<div fxLayout="column" fxLayoutAlign="space-between center">
  <mat-spinner></mat-spinner>
  <h6 *ngIf="!changeMessage">{{ message }}</h6>
  <span *ngIf="changeMessage">
    {{ "iot.dashboard.shared.loading" | translate }}
  </span>
</div>
